import "./Services.module.css";
import MainNavigation from "@/reusable_sections/Header";
import InvitationOverview from "./sections/InvitationOverview";
import OurCoreServices from "./sections/OurCoreServices";
import VolunteerSignUp from "./sections/VolunteerSignUp";
import OurPlumbingSpecialties from "./sections/OurPlumbingSpecialties";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <MainNavigation />
      <InvitationOverview />
      <OurCoreServices />
      <VolunteerSignUp />
      <OurPlumbingSpecialties />
      <Footer />
    </div>;
}